class ClickAndCollect {
	constructor(containerElement) {
		this.contentElementContainer = containerElement
		this.addition = ''
		this.firstname = ''
		this.name = ''
		this.email = ''
		this.priceType = 1
		this.basketItems = []
		this.translations = JSON.parse(this.contentElementContainer.dataset.translations)

		this.orderStatusContainerElement = this.contentElementContainer.querySelector('.clickandcollect-orderstatus')
		this.formContainerElement = this.contentElementContainer.querySelector('.clickandcollect-form-container')
		this.introContainerElement = this.contentElementContainer.querySelector('.clickandcollect-intro')
		this.introButtonElements = this.contentElementContainer.querySelectorAll('.clickandcollect-intro button')
		this.basketContainerElement = this.contentElementContainer.querySelector('.clickandcollect-basket-container')
		this.basketElement = this.contentElementContainer.querySelector('.clickandcollect-basket')
		this.basketItemTemplate = this.basketElement.querySelector('.template')
		this.basketListElement = this.basketElement.querySelector('.list')
		this.totalPriceElement = this.basketElement.querySelector('.totalPrice')
		this.depositCountElement = this.basketElement.querySelector('.depositCount')
		this.depositPriceElement = this.basketElement.querySelector('.depositPrice')
		this.totalDepositPriceElement = this.basketElement.querySelector('.totalDepositPrice')
		this.addToBasketButtonElements = this.contentElementContainer.querySelectorAll('.add-to-basket')
		this.additionRadioElements = this.contentElementContainer.querySelectorAll('input[name="clickAndCollect[addition]"]')
		this.priceTypeRadioElements = this.contentElementContainer.querySelectorAll('input[name="clickAndCollect[pricetype]"]')
		this.price1LabelElement = this.contentElementContainer.querySelector('.priceTypeLabel1')
		this.price1LabelSourceElement = this.contentElementContainer.querySelector('[data-price1label]')
		this.price1Label = this.price1LabelSourceElement ? this.price1LabelSourceElement.dataset.price1label : ''
		this.price2LabelElement = this.contentElementContainer.querySelector('.priceTypeLabel2')
		this.price2LabelSourceElement = this.contentElementContainer.querySelector('[data-price2label]')
		this.price2Label = this.price2LabelSourceElement ? this.price2LabelSourceElement.dataset.price2label : ''
		this.price3LabelElement = this.contentElementContainer.querySelector('.priceTypeLabel3')
		this.price3LabelSourceElement = this.contentElementContainer.querySelector('[data-price3label]')
		this.price3Label = this.price3LabelSourceElement ? this.price3LabelSourceElement.dataset.price3label : ''
		this.price4LabelElement = this.contentElementContainer.querySelector('.priceTypeLabel4')
		this.price4LabelSourceElement = this.contentElementContainer.querySelector('[data-price4label]')
		this.price4Label = this.price4LabelSourceElement ? this.price4LabelSourceElement.dataset.price4label : ''
		this.firstnameInputElement = this.contentElementContainer.querySelector('input[name="clickAndCollect[firstname]"]')
		this.nameInputElement = this.contentElementContainer.querySelector('input[name="clickAndCollect[name]"]')
		this.emailInputElement = this.contentElementContainer.querySelector('input[name="clickAndCollect[email]"]')
		this.submitButtonElement = this.contentElementContainer.querySelector('.clickandcollect-basket--submit')
		this.timeslotMismatchElement = this.contentElementContainer.querySelector('.clickandcollect-timeslot-mismatch')
		this.menusElement = this.contentElementContainer.querySelector('.clickandcollect-menus')

		if (this.orderStatusContainerElement) {
			this.introContainerElement.style.display = 'none';
			this.formContainerElement.style.display = 'none';
		}

		if (this.timeslotMismatchElement) {
			let orderTimeslotFrom = this.timeslotMismatchElement.dataset["orderTimeslotFrom"]
			let orderTimeslotTo = this.timeslotMismatchElement.dataset["orderTimeslotTo"]
			let orderTimeslotNow = new Date().getHours() * 60 + new Date().getMinutes()
			if (orderTimeslotFrom < orderTimeslotNow && orderTimeslotTo > orderTimeslotNow) {
				console.log('orderTimeslot valid')
				this.menusElement.style.display = ''
				this.timeslotMismatchElement.style.display = 'none'
			} else {
				console.log('orderTimeslot invalid')
				this.menusElement.style.display = 'none'
				this.timeslotMismatchElement.style.display = ''
			}
		}

		let checked = this.contentElementContainer.querySelector('[name="clickAndCollect[addition]"]:checked')
		if (checked) {
			this.addition = checked.value
		}

		this.addEventListeners()
	}

	render() {
		this.basketListElement.innerHTML = ''

		let totalPrice = 0
		let totalItems = 0
		this.totalPriceElement.innerHTML = ''

		if (this.price1Label) {
			this.price1LabelElement.innerHTML = this.price1Label
			this.price1LabelElement.parentNode.style.display = ''
		} else {
			this.price1LabelElement.parentNode.style.display = 'none'
		}
		if (this.price2Label) {
			this.price2LabelElement.innerHTML = this.price2Label
			this.price2LabelElement.parentNode.style.display = ''
		} else {
			this.price2LabelElement.parentNode.style.display = 'none'
		}
		if (this.price3Label) {
			this.price3LabelElement.innerHTML = this.price3Label
			this.price3LabelElement.parentNode.style.display = ''
		} else {
			this.price3LabelElement.parentNode.style.display = 'none'
		}
		if (this.price4Label) {
			this.price4LabelElement.innerHTML = this.price4Label
			this.price4LabelElement.parentNode.style.display = ''
		} else {
			this.price4LabelElement.parentNode.style.display = 'none'
		}
		if (!this.price1Label && !this.price2Label && !this.price3Label && !this.price4Label) {
			this.price1LabelElement.parentNode.parentNode.style.display = 'none'
			this.price1LabelElement.parentNode.parentNode.previousSibling.style.display = 'none'
		}

		const getPriceFromItemWithType = (dataObject) => {
			let price = dataObject['price' + this.priceType]
			if (!price) {
				price = dataObject['price1']
			}
			return price
		}

		let depositCount = 0;
		let depositPrice = parseFloat(this.depositPriceElement.dataset['price']);
		if (depositPrice) {
			this.depositPriceElement.parentElement.style.display = ''
		} else {
			this.depositPriceElement.parentElement.style.display = 'none'
		}

		this.basketItems.forEach(item => {
			let itemElement = this.basketItemTemplate.cloneNode(true)
			itemElement.classList.remove('template')
			itemElement.dataset['identifier'] = item.identifier
			itemElement.querySelector('.name').innerHTML = item.name
			itemElement.querySelector('.price').innerHTML = parseFloat(getPriceFromItemWithType(item)).toFixed(2)
			itemElement.querySelector('.count').innerHTML = item.count
			depositCount += item.count
			itemElement.querySelector('.totalItemPrice').innerHTML = (item.count * getPriceFromItemWithType(item)).toFixed(2)
			totalPrice = totalPrice + parseFloat((item.count * getPriceFromItemWithType(item)).toFixed(2))
			totalItems += item.count
			this.basketListElement.appendChild(itemElement)
		})

		let checked = this.contentElementContainer.querySelector('[name="clickAndCollect[addition]"]:checked')
		if (checked && checked.dataset.price1) {
			let itemElement = this.basketItemTemplate.cloneNode(true)
			itemElement.classList.remove('template')
			itemElement.querySelector('.countIncrease').style.display = 'none'
			itemElement.querySelector('.countDecrease').style.display = 'none'
			itemElement.querySelector('.name').innerHTML = checked.dataset.label
			itemElement.querySelector('.price').innerHTML = parseFloat(getPriceFromItemWithType(checked.dataset)).toFixed(2)
			itemElement.querySelector('.count').innerHTML = totalItems
			itemElement.querySelector('.totalItemPrice').innerHTML = (parseFloat(getPriceFromItemWithType(checked.dataset)) * totalItems).toFixed(2)
			totalPrice = totalPrice + parseFloat(getPriceFromItemWithType(checked.dataset)) * totalItems
			this.basketListElement.appendChild(itemElement)
		}

		if (depositPrice && depositCount) {
			console.log({depositCount, depositPrice})
			this.depositCountElement.innerHTML = depositCount
			this.depositPriceElement.innerHTML = (depositPrice).toFixed(2)
			this.totalDepositPriceElement.innerHTML = (depositCount * depositPrice).toFixed(2)

			totalPrice += parseFloat((depositCount * depositPrice).toFixed(2))
		}

		console.log({addition: this.addition, firstname: this.firstname, name: this.name, email: this.email, priceType: this.priceType, basketItems: this.basketItems}, 'data object')

		this.totalPriceElement.innerHTML = (totalPrice).toFixed(2)

		if (this.basketItems.length > 0) {
			this.basketContainerElement.classList.remove('clickandcollect-basket-container--hidden')
			this.basketContainerElement.scrollIntoView({ behavior: 'smooth'})
		} else {
			this.basketContainerElement.classList.add('clickandcollect-basket-container--hidden')
		}
	}

	addBasketItem(newItem) {
		let itemExists = false

		this.basketItems.forEach(item => {
			if (item.identifier === newItem.identifier) {
				itemExists = true
				return
			}
		})

		if (!itemExists) {
			this.basketItems.push(newItem)
		}
	}

	increaseBasketItemCount(identifier) {
		this.basketItems.forEach(item => {
			if (item.identifier === identifier) {
				if (item.stock > item.count) {
					item.count++
				}
				return
			}
		})
	}

	decreaseBasketItemCount(identifier) {
		this.basketItems.forEach((item, index, object) => {
			if (item.identifier === identifier) {
				item.count--
				if (item.count <= 0) {
					object.splice(index, 1)
				}
				return
			}
		})
	}

	submitAction() {
		if (!this.addition && this.formContainerElement.dataset['type'] !== 'foodWaste') {
			alert(this.translations.additionMissing)
			return
		}
		if (!this.priceType) {
			alert(this.translations.priceTypeMissing)
			return
		}
		if (!this.firstname) {
			alert(this.translations.firstnameMissing)
			return
		}
		if (!this.name) {
			alert(this.translations.nameMissing)
			return
		}
		if (!this.email || !this.validateEmail(this.email)) {
			alert(this.translations.emailMissing)
			return
		}

		this.submitButtonElement.classList.add('running')

		let formValues = {
			menuItems: this.basketItems,
			addition: this.addition,
			priceType: this.priceType,
			firstname: this.firstname,
			name: this.name,
			email: this.email
		}

		let data = {
			clickAndCollect: formValues
		};
		if (this.formContainerElement.dataset['type'] === 'foodWaste') {
			data = {
				foodWaste: formValues
			};
		}

		let xhr = new XMLHttpRequest();
		xhr.open("POST", this.formContainerElement.getAttribute('action'), true);
		xhr.setRequestHeader('Content-Type', 'application/json');
		xhr.send(JSON.stringify(data));
		xhr.onreadystatechange = () => {
			if(xhr.readyState === 4 && xhr.status === 200) {
				// alert(xhr.responseText);
				this.handleSubmitResponse(xhr.responseText)
			}

			this.submitButtonElement.classList.remove('running')
		}
	}

	handleSubmitResponse(responseText) {

		let response;

		try {
			response = JSON.parse(responseText);
		} catch (e) {
			//@todo handle big fail, probably network
			console.log(e, responseText);
			alert(responseText);
			return;
		}

		if (!response.status) {
			//@todo handle fail, probably saferpay, wond or neos
			console.log(response, responseText);
			if (response.message) {
				alert(response.message)
			} else {
				alert(responseText);
			}
			return;
		}

		window.location.href = response.redirect;

	}

	addEventListeners() {
		this.introButtonElements.forEach(element => {
			element.addEventListener('click', event => {
				event.preventDefault()
				this.introContainerElement.style.display = 'none'
				this.formContainerElement.style.display = 'block'
			})
		})

		this.additionRadioElements.forEach(element => {
			element.addEventListener('change', event => {
				let checked = this.contentElementContainer.querySelector('[name="clickAndCollect[addition]"]:checked')
				if (checked) {
					this.addition = checked.value
				} else {
					this.addition = ''
				}
				this.render()
			})
		})

		this.priceTypeRadioElements.forEach(element => {
			element.addEventListener('change', event => {
				let checked = this.contentElementContainer.querySelector('[name="clickAndCollect[pricetype]"]:checked')
				if (checked) {
					this.priceType = checked.value
				} else {
					this.priceType = 1
				}
				this.render()
			})
		})

		this.firstnameInputElement.addEventListener('keyup', event => {
			this.firstname = event.target.value

			if (this.firstname) {
				event.target.parentElement.classList.add('has-value')
			} else {
				event.target.parentElement.classList.remove('has-value')
			}

			if (event.code === 'Enter') {
				this.submitAction()
			}
		})

		this.nameInputElement.addEventListener('keyup', event => {
			this.name = event.target.value

			if (this.name) {
				event.target.parentElement.classList.add('has-value')
			} else {
				event.target.parentElement.classList.remove('has-value')
			}

			if (event.code === 'Enter') {
				this.submitAction()
			}
		})

		this.emailInputElement.addEventListener('keyup', event => {
			this.email = event.target.value

			if (this.email) {
				event.target.parentElement.classList.add('has-value')
			} else {
				event.target.parentElement.classList.remove('has-value')
			}

			if (event.code === 'Enter') {
				this.submitAction()
			}
		})

		this.addToBasketButtonElements.forEach((element) => {
			element.addEventListener('click', event => {
				event.preventDefault()
				if (!event.detail || event.detail !== 1) {
					return
				}

				this.addBasketItem({
					identifier: event.target.dataset['identifier'],
					name: event.target.dataset['name'],
					count: 1,
					price1: event.target.dataset['price1'],
					price2: event.target.dataset['price2'],
					price3: event.target.dataset['price3'],
					price4: event.target.dataset['price4'],
					stock: event.target.dataset['stock']
				})
				this.basketContainerElement.scrollIntoView({ behavior: 'smooth'});
				this.render()

			})
		})

		this.basketListElement.addEventListener('click', event => {
			if (event.target.classList.contains('countIncrease')) {
				event.preventDefault()

				this.increaseBasketItemCount(event.target.closest('.clickandcollect-basket--item').dataset['identifier'])
				this.render()

			}else if (event.target.classList.contains('countDecrease')) {
				event.preventDefault()

				this.decreaseBasketItemCount(event.target.closest('.clickandcollect-basket--item').dataset['identifier'])
				this.render()
			}
		})

		this.submitButtonElement.addEventListener('click', event => {
			event.preventDefault()

			this.submitAction()
		})
	}

	validateEmail(email) {
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(String(email).toLowerCase());
	}

}

let clickAndCollectContainer = document.querySelector('.dotpulse-eldora-restaurant-clickandcollect')
if (clickAndCollectContainer) {
	new ClickAndCollect(clickAndCollectContainer)
}
